import { render, staticRenderFns } from "./KbSettingPage.vue?vue&type=template&id=9f835514&scoped=true"
import script from "./KbSettingPage.vue?vue&type=script&lang=js"
export * from "./KbSettingPage.vue?vue&type=script&lang=js"
import style0 from "./KbSettingPage.vue?vue&type=style&index=0&id=9f835514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f835514",
  null
  
)

export default component.exports